import React from 'react';
import ThinkingIndicator from './ThinkingIndicator';

/**
 * Container component for the thinking indicator
 * Encapsulates the conditional rendering and styling logic
 * 
 * @param {boolean} isVisible - Whether the indicator should be visible
 * @param {number} confidenceScore - The confidence score to display
 * @returns {JSX.Element|null} The thinking indicator or null
 */
const ThinkingIndicatorContainer = ({ isVisible, confidenceScore }) => {
  if (!isVisible) return null;
  
  return (
    <div className="thinking-indicator-container py-4">
      <ThinkingIndicator confidenceScore={confidenceScore} />
    </div>
  );
};

export default ThinkingIndicatorContainer; 